import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PrivateAxios, publicAxios } from '../../apiEcommerce';

const initialState = {
  bestProducts: [],
  status: 'idle',
  error: null,
};

export const fetchBestPro = createAsyncThunk('bestProducts/fetchBestPro', async () => {
  const response = await PrivateAxios.get('/api/ecomerce/cart/top-best-seller');
  return response.data.data;
});

const bestSellerProductsSlice = createSlice({
  name: 'bestProducts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBestPro.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchBestPro.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.bestProducts = action.payload;
      })
      .addCase(fetchBestPro.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default bestSellerProductsSlice.reducer;